var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{ref:"cat"},[_c('img',{class:_vm.code + ' sc-image',attrs:{"src":require("../../../assets/smart-carousel/images/blank.png"),"alt":"Electronic Device Insurance"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }